import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'
import reducers from '../reducers'
import preloadedState from './preloaded-state'

export default function configureStore() {
  const store = createStore(
    combineReducers({
      ...reducers
    }),
    preloadedState,
    compose(
      // middleware
      applyMiddleware(...middleware()),
      // devtools
      window.devToolsExtension ? window.devToolsExtension() : f => f
    )
  )

  return store
}

function middleware() {
  const middleware = [thunk]
  if (process.env.NODE_ENV === 'development') {
    // support disabling the logger (@Rowno hates it)
    if (window.localStorage.reduxlogger !== 'false') {
      middleware.push(createLogger({ collapsed: true }))
    }
  }
  return middleware
}
